import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import {TABLES} from '../../../../Apis/Tables';
import { useSelector} from 'react-redux';
import TableFunction from '../../../../components/table/TableFunction';
import ContractDataApp from './ContractDataApp';
import {VIEW_TYPE} from '../../../../enums/ViewType';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ContractorCardsApp = (
    {
        searchElement,
        setSearchElement,
        contractorId,
        modified,
        setModified,
        finalArray,
        setCriteria,
        setIsAllChecked,
        selectedList,
        setSelectedList,
        search,
        setSearch,
        setBodyForExport
    }
) => {

    const { t } = useTranslation(); // Destructure translation function for multi-language support
    const navigate = useNavigate(); // Set up navigation functionality
    const [results, setResults] = useState(null); // State to store results for the document list
    const [option, setOption] = useState(`${TABLES.CONTRACTORS}`); // State to store the selected table option (contracts)
    const elementRefTable = useRef(null); // Reference to the element for positioning (used for layout effects)
    // Access state values from Redux store
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Access development state for conditional rendering
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Access user permission data

    // useLayoutEffect hook to adjust positioning of elements when the view changes
    useEffect(() => {
        if (elementRefTable?.current) {
            const rect = elementRefTable.current.getBoundingClientRect(); // Get the element's position on the screen
            const distanceTop = rect.top + 0; // Calculate the top position of the element
            elementRefTable.current.style.setProperty('--top-value', `${distanceTop}px`); // Update the custom CSS property for positioning
        }
    }, [results]); // Dependency array ensures the effect runs when the 'view' prop changes

    // ContractDataApp hook for handling contract-related data logic
    const { getData, getDataAdvancedSearch } = ContractDataApp({
        searchElement,
        setSearchElement,
        contractorId,
        setCriteria,
        setBodyForExport,
        setResults,
        option,
        modified,
        setModified,
        finalArray,
        search,
        setSearch,
        viewType: VIEW_TYPE.GRID.viewType
    });


    // Use the TableFunction component to handle table logic (checkbox selection, pagination, etc.)
    const { handleCheckboxChange, handleDeleteAll,
        pagination, page, rowsPerPage, } = TableFunction({
        selectedList,
        setSelectedList, // Callback to update the selected rows
        data: results, // Table data
        labelRowsPerPage: 'contractors_per_page', // Label for rows per page
        hasContainer: true, // Enable container for the table
        fixedPagination: false, // Disable fixed pagination
        setIsAllChecked,
        view: VIEW_TYPE.GRID.name,

        searchElement,
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray,//New - apply only with advanced search
    });

    // Return the necessary variables and functions from the component
    return {
        DEV,
        permission,
        t, // Translation function
        navigate, // Navigation function
        elementRefTable, // Reference to the tab element
        results, // Document list results
        pagination, // Pagination component state
        handleCheckboxChange, // Checkbox change handler
        handleDeleteAll,
        setResults, // Function to update results
        option, // Selected table option (contracts)
        page, // Current page number
        rowsPerPage, // Number of rows per page
    };
}

export default ContractorCardsApp
